export const BulkVisitorAnswerMetadataKey = Object.freeze({
    Language: 'language',
    TrustedFormUrl: 'trusted_form_url',
    PubId: 'pub_id',
    JornayaId: 'jornaya_id',
    UniversalLeadId: 'universal_leadid',
    RingbaImpressionId: 'ringba_impression_id',
    Vertical: 'vertical',
})
